export const editorLabels = {
  // Block types
  normal: 'Normal',
  heading1: 'Encabezado 1',
  heading2: 'Encabezado 2',
  heading3: 'Encabezado 3',
  heading4: 'Encabezado 4',
  heading5: 'Encabezado 5',
  heading6: 'Encabezado 6',
  numberedList: 'Lista numerada',
  bulletedList: 'Lista con puntos',
  quote: 'Cita',
  codeBlock: 'Bloque de código',

  // Alignment options
  leftAlign: 'Alinear izquierda',
  centerAlign: 'Alinear centro',
  rightAlign: 'Alinear derecha',
  justifyAlign: 'Justificar',
  startAlign: 'Alinear inicio',
  endAlign: 'Alinear final',

  // Text transformation options
  lowercase: 'Minúsculas',
  uppercase: 'Mayúsculas',
  capitalize: 'Capitalizar',
  subscript: 'Subíndice',
  superscript: 'Superíndice',

  // Toolbar button labels
  undo: 'Deshacer',
  redo: 'Rehacer',
  formatBold: 'Formato negrita',
  formatItalic: 'Formato cursiva',
  formatUnderline: 'Formato subrayado',
  formatStrikethrough: 'Formato tachado',
  outdent: 'Disminuir sangría',
  indent: 'Aumentar sangría',
  clearFormatting: 'Limpiar formato',

  // Toolbar dropdown labels
  formattingOptions: 'Opciones de formato para estilo de texto',
  textAlignment: 'Opciones de formato para alineación de texto',
  additionalTextStyles: 'Opciones de formato para estilos de texto adicionales',
};
